import { fetchBaseQuery as fetchBaseQueryCall } from '@reduxjs/toolkit/dist/query/react';

import { getCookie } from '@app/utils/request';

export const getCsrfHeader = () => getCookie('csrf_token') || '';

const getHeaders = (headers?: string[][]) => headers || [];

const fetchBaseQuery = (headersData?: string[][]) =>
    fetchBaseQueryCall({
        baseUrl: process.env.NODE_ENV !== 'test' ? '/' : 'http://localhost/',
        prepareHeaders: (headers) => {
            // workaround to prevent setting of content-type, applicable while sending file data
            if (!headers.has('x-auto-content-type')) {
                headers.set('content-type', `application/json`);
            } else {
                headers.delete('x-auto-content-type');
            }

            headers.set('x-requested-with', `XMLHttpRequest`);
            headers.set('X-CSRF-Token', getCsrfHeader());

            getHeaders(headersData).forEach(([key, value]) => {
                headers.set(key, value);
            });

            return headers;
        },
    });

export default fetchBaseQuery;
